import { ReactNode, useEffect } from "react"
import { Link } from "@inertiajs/react"
import Image from "../Image"
import RootLayout from "./Root"
import logo from "@/assets/img/logo.svg"

const AdminLayout = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    document.body.classList.add("bg-gray-100")
  })

  return (
    <RootLayout>
      <div className="mx-auto w-full max-w-xl">
        <header className="flex h-20 items-center justify-center">
          <Link href="/">
            <Image src={logo} className="h-5" />
          </Link>
        </header>

        <main className="flex-1">{children}</main>
      </div>
    </RootLayout>
  )
}
export default AdminLayout
